import projectOne from "../assets/project-1.png";
import projectTwo from "../assets/project-2.png";
import projectThree from "../assets/project-3.png";

const projects = {
  1: {
    title: "SoMe Platform",
    image: projectOne,
    description: (
      <>
        <p>
          *This project does not exist!
          <br /> Testing this site with a fictitious project, aiming to show my
          real projects in future updates.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  2: {
    title: "Productivity App",
    image: projectTwo,
    description: (
      <>
        <p>
          *This project does not exist!
          <br /> Testing this site with a fictitious project, aiming to show my
          real projects in future updates.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
  3: {
    title: "Food Delivery App",
    image: projectThree,
    description: (
      <>
        <p>
          *This project does not exist!
          <br /> Testing this site with a fictitious project, aiming to show my
          real projects in future updates.
        </p>
      </>
    ),
    github: "https://github.com",
    demo: "https://netlify.com",
  },
};

export default projects;
